export enum EnumEstadoUso {
  Provisional = 1,
  Definitivo
}
